import { Asset } from "../../types/Asset";
import { PropsWithChildren } from "react";
import { Link } from "react-router-dom";
import { useProductTranslations } from "../../hooks/TranslationHooks";
import { unwrapAsset } from "../../utils/CockpitUtils";
import { useCategory } from "../../hooks/ProductHooks";
import ImageOrVideo from "../ImageOrVideo";
import CategoryIcons from "./CategoryIcons";
import {
  productCategoryTitle,
  productCategoryUrl
} from "../../utils/ProductCategoryUtils";
import { shopUrl } from "../../config/urls";
import "./style.scss";

const CategoryPreview = ({
  categoryId,
  description,
  image,
  showIcons,
  isShop,
  children
}: PropsWithChildren<{
  categoryId: string;
  description?: string;
  image?: Asset;
  showIcons?: boolean;
  isShop?: boolean;
}>) => {
  const tp = useProductTranslations();
  const category = useCategory(categoryId);
  if (!category) {
    return null;
  }
  const img = image || category.shop_herobox_background_image;
  console.log("CategoryPreview", category);

  return (
    <div className="category-preview" role="listitem">
      <Link
        to={
          isShop ? productCategoryUrl(category) || shopUrl : `/${category.path}`
        }
      >
        <ImageOrVideo
          image={img ? unwrapAsset(img) : false}
          className="bkg"
          centerImage
        />
        <div className="content">
          <h4 style={{ fontSize: "1.4em" }}>
            {productCategoryTitle(category, tp)}
          </h4>
          <p style={{ fontSize: "0.85em", marginBottom: 0 }}>
            {description || category.short_description}
          </p>
          {showIcons && <CategoryIcons />}
          {children}
        </div>
      </Link>
    </div>
  );
};

export default CategoryPreview;
